import React from "react";

export const PageHero = ({ label, headline, subline, children, testId = "page-hero" }) => (
  <section className="px-6 sm:px-8 pt-16 sm:pt-20 pb-14" data-testid={testId}>
    <div className="max-w-4xl mx-auto">
      {label && (
        <p className="font-semibold text-xs uppercase tracking-[0.22em] text-[#C8703A]">{label}</p>
      )}
      <h1 className="mt-6 font-fraunces font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1F1F1C]" data-testid={`${testId}-headline`}>
        {headline}
      </h1>
      {subline && (
        <p className="mt-7 text-base md:text-lg text-[#4A463F] leading-relaxed max-w-2xl">{subline}</p>
      )}
      {children}
    </div>
  </section>
);

export default PageHero;
